import { Action, createReducer, on } from "@ngrx/store";
import * as GameThemeSettingsActions from "./gameThemeSettings.actions"
import { GameThemeSettingsState, GAME_THEME_SETTINGS_INIT_STATE, DEFAULT_AND_FREE_AVATARS } from "./gameThemeSettings.state";
import { DEFAULT_AVATARS, DEFAULT_BACKGOUNDS, DEFAULT_CARD_STYLES, DEFAULT_FELTS } from "@soposopo/sopo-models";

const _gameThemeSettingsReducer = createReducer(

    GAME_THEME_SETTINGS_INIT_STATE,

    on(
        GameThemeSettingsActions.setFelt,
        (state, action) => ({
            ...state,
            felt: action.felt,
        })
    ),

    on(
        GameThemeSettingsActions.setUnlockedFelts,
        (state, action) => ({
            ...state,
            unlockedFelts: [...DEFAULT_FELTS, ...action.felts],
        })
    ),

    on(
        GameThemeSettingsActions.setUnlockedBackgrounds,
        (state, action) => ({
            ...state,
            unlockedBackgrounds: [...DEFAULT_BACKGOUNDS, ...action.backgrounds],
        })
    ),

    on(
        GameThemeSettingsActions.setUnlockedCardStyles,
        (state, action) => ({
            ...state,
            unlockedCardStyles: [...DEFAULT_CARD_STYLES, ...action.cardStyles],
        })
    ),

    on(
        GameThemeSettingsActions.setUnlockedAvatars,
        (state, action) => {
            return {
                ...state,
                unlockedAvatars: [...DEFAULT_AND_FREE_AVATARS, ...action.avatars],
            }
        }
    ),

    on(
        GameThemeSettingsActions.setBackground,
        (state, action) => ({
            ...state,
            background: action.background,
        })
    ),

    on(
        GameThemeSettingsActions.setCardStyle,
        (state, action) => ({
            ...state,
            cardStyle: action.cardStyle,
        })
    ),

    on(
        GameThemeSettingsActions.resetSettings,
        (state, action) => ({
            ...state,
            ...GAME_THEME_SETTINGS_INIT_STATE
        })
    ),

    on(
        GameThemeSettingsActions.setBetSizes,
        (state, action) => ({
            ...state,
            betSizes: action.betSizes,
        })
    ),

    on(
        GameThemeSettingsActions.setRaiseSizes,
        (state, action) => ({
            ...state,
            raiseSizes: action.raiseSizes,
        })
    ),

    on(
        GameThemeSettingsActions.setThemeOptions,
        (state, action) => ({
            ...state,
            [action.optionType]: action.optionValue,
        })
    ),

    on(
        GameThemeSettingsActions.setTransactions,
        (state, action) => ({
            ...state,
            transactions: action.transactions,
        })
    ),

    on(
        GameThemeSettingsActions.setPosition,
        (state, action) => ({
            ...state,
            position: action.position,
        })
    ),

    on(
        GameThemeSettingsActions.setBetPresets,
        (state, action) => ({
            ...state,
            betPresets: action.betPresets,
        })
    ),
);

export function gameThemeSettingsReducer(state: GameThemeSettingsState, action: Action) {
    return _gameThemeSettingsReducer(state, action);
}
